import { Extension } from '@tiptap/core';
import '@tiptap/extension-text-style';

// Same pattern as font-size-extension.ts: a command that sets a `style`
// attribute on the shared TextStyle mark, scoped to `color`. Avoids adding
// @tiptap/extension-color as a dependency — one hand-rolled TextStyle
// attribute extension covers both. Requires `TextStyle` to already be
// registered on the editor.
declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    textColor: {
      setTextColor: (color: string) => ReturnType;
      unsetTextColor: () => ReturnType;
    };
  }
}

export const TextColor = Extension.create({
  name: 'textColor',

  addOptions() {
    return { types: ['textStyle'] };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types as string[],
        attributes: {
          color: {
            default: null,
            parseHTML: element => element.style.color || null,
            renderHTML: attributes => {
              if (!attributes.color) {
                return {};
              }
              return { style: `color: ${attributes.color as string}` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setTextColor:
        (color: string) =>
        ({ chain }) =>
          chain().setMark('textStyle', { color }).run(),
      unsetTextColor:
        () =>
        ({ chain }) =>
          chain().setMark('textStyle', { color: null }).removeEmptyTextStyle().run(),
    };
  },
});
